import { render, staticRenderFns } from "./TableMatrixV2.vue?vue&type=template&id=8419efca&scoped=true"
import script from "./TableMatrixV2.vue?vue&type=script&lang=js"
export * from "./TableMatrixV2.vue?vue&type=script&lang=js"
import style0 from "./TableMatrixV2.vue?vue&type=style&index=0&id=8419efca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8419efca",
  null
  
)

export default component.exports